import koLocale from 'element-ui/lib/locale/lang/ko'
const ko = {
  message: {
    'toLogin': '계좌 번호를 등록하다.',
    'login': '로그인',
    'userName': '사용자 이름',
    'enterprise': '기업 번호',
    'mobilePhone': '핸드폰 번호',
    'ObtAccount': 'Obt계정',
    'password': '암호',
    'verificationCode': '인증코드',
    'home': '첫 페이지',
    'ItineraryBooking': '일정 예정',
    'myApplication': '나의 신청',
    'myApproval': '나의 심사 비준',
    'myOrder': '나의 주문서',
    'myItinerary': '나의 스케줄',
    'dataManagement': '데이터 관리',
    'airTickets': '국내 비행기표',
    'International': '국제비행기표',
    'hotel': '호텔 예약',
    'trainTickets': '기차표',
    'notBooking': '예약 불가',
    'pleaseEnableTrToBook': 'tr 예정 권한을 켜십시오',
    'cannotBeBooked': '심사허가 스트림 데이터 보호하지 않아 예약 불가',
    'certificateInformation': '증명서의 정보를 보호해주세요.'
  },
  'AuthenticationFailure': '인증이 유효하지 않습니다.',
  '00000': '알 수 없는 오류!',
  '00001': '저장 실패!',
  '00002': '저장에 성공하였습니다!',
  '00003': '삭제에 성공함！',
  '00004': '삭제하는 데 실패했습니다！',
  '10001': '사용자 이름이 충돌합니다. 기업 번호를 입력하십시오!',
  ...koLocale
}

export default ko



// WEBPACK FOOTER //
// ./src/i18n/langs/korean.js